import { v4 } from 'uuid';
import { bigBrain } from '@mondaydotcomorg/bigbrain/BigBrainWeb';
import { HostEnvironment } from '../types.js';
import TransactionsManager from './transactionsManager.js';

const BIGBRAIN_EVENT_NAME = 'trident-metrics';
const BIGBRAIN_SAMPLE_RATE = 1 / 200;
// for Trident internal use only
class Tracker {
    constructor({ host, api, preloadedMFs }) {
        this.uuid = v4();
        this.host = host;
        this.api = api;
        this.bigbrain = bigBrain(host.environment, host.name);
        if (this.host.environment === HostEnvironment.production && this.api?.loggerService?.startTransaction) {
            this.transactionsManager = new TransactionsManager(this.api.loggerService.startTransaction, preloadedMFs);
        }
        else {
            this.transactionsManager = null;
        }
    }
    track(name, data = {}) {
        if (this.transactionsManager) {
            this.transactionsManager.track(name, data);
        }
        this.bigbrainSample(name, data);
    }
    cleanBigbrainData(data) {
        const { error } = data;
        return {
            ...data,
            error: error ? error.message : undefined,
            element: undefined,
        };
    }
    bigbrainSample(name, data) {
        if (Math.random() < BIGBRAIN_SAMPLE_RATE) {
            const event = {
                kind: name,
                data: {
                    uuid: this.uuid,
                    time: Date.now(),
                    ...this.cleanBigbrainData(data),
                },
            };
            this.bigbrain.track(BIGBRAIN_EVENT_NAME, event);
        }
    }
}

export { Tracker };
